import axios from 'axios';
import { CustomMultiSelectModel } from '../components/CustomMultiSelect';
import { Helpers } from '../helpers/Helpers';
import { AddWelcomeRequest } from '../models/request/welcome/AddWelcomeRequest';
import { GetWelcomeListPagingAndFilterRequest } from '../models/request/welcome/GetWelcomeListPagingAndFilterRequest';

export class WelcomeService {
    static async getWelcomeList(_isOut: boolean | undefined = undefined, _selectedWelcomeStatuss: CustomMultiSelectModel[] | undefined = undefined, _removeUsed: boolean | undefined = undefined, _customerId: string | undefined = undefined) {
        try {
            var inputObj = {
                isOut: _isOut,
                selectedWelcomeStatuss: _selectedWelcomeStatuss,
                removeUsed: _removeUsed,
                customerId: _customerId
            };

            console.log('SERVICE CALL - getWelcomeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Welcome/getWelcomeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getWelcomeListByAntrepoOfferId(_antrepoOfferId: string) {
        try {
            var inputObj = {
                antrepoOfferId: _antrepoOfferId
            };

            console.log('SERVICE CALL - getWelcomeListByAntrepoOfferId', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Welcome/getWelcomeListByAntrepoOfferId', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportWelcomeList(inputObj: GetWelcomeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportWelcomeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Welcome/exportWelcomeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getWelcomeListPagingAndFilter(inputObj: GetWelcomeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetWelcomeListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Welcome/GetWelcomeListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addWelcome(inputObj: AddWelcomeRequest) {
        try {
            console.log('SERVICE CALL - AddWelcome', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Welcome/AddWelcome', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteWelcome(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteWelcome', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Welcome/deleteWelcome', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async changeWelcomeStatus(_welcomeIds: string[], _welcomeStatusId: string) {
        try {
            var inputObj = {
                welcomeIds: _welcomeIds,
                WelcomeStatusId: _welcomeStatusId
            };

            console.log('SERVICE CALL - changeWelcomeStatus', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Welcome/changeWelcomeStatus', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getWelcomeById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getWelcomeById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Welcome/getWelcomeById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}